(function () {
    const ONE_SIZE_CODES = ["OS", "OS1"];
    const CHILD_SIZE_CODES = ["YXXS", "YXS", "YS", "YM", "YL", "7IN", "8IN"];
    const CHILD_SIZE_PREFIXES = ["y", "7in", "8in"];

    function isOneSize(codes) {
        return (
            codes.length === 1 &&
            ONE_SIZE_CODES.includes(codes[0].trim().toUpperCase())
        );
    }

    function updateYouthSizeClassification() {
        const productAttributes = document.querySelector(
            "#product-attributes-container"
        );
        const productVue = productAttributes && productAttributes.__vue__;

        if (
            !productVue ||
            !Array.isArray(productVue.childSizeIdentifier) ||
            typeof productVue.generateSizeList !== "function"
        ) {
            return;
        }

        const missingChildPrefixes = CHILD_SIZE_PREFIXES.filter(function (prefix) {
            return !productVue.childSizeIdentifier.includes(prefix);
        });

        if (missingChildPrefixes.length) {
            productVue.childSizeIdentifier.push.apply(
                productVue.childSizeIdentifier,
                missingChildPrefixes
            );

            // Preserve the intended child-size order in both native selectors.
            productVue.sizesOrder = CHILD_SIZE_CODES.concat(
                productVue.sizesOrder.filter(function (code) {
                    return !CHILD_SIZE_CODES.includes(code);
                })
            );

            if (productVue.selectedColor && productVue.selectedColor.sizes) {
                productVue.generateSizeList(productVue.selectedColor);
            }
        }
    }

    function updateOneSizeLabels() {
        // Dealer product selector
        document
            .querySelectorAll(".size-selector-dealer__adult")
            .forEach(function (section) {
                const codes = Array.from(
                    section.querySelectorAll("li.dealer-selector-size label")
                ).map(function (label) {
                    return label.textContent;
                });

                if (isOneSize(codes)) {
                    const heading = section.querySelector("h2");

                    if (heading && heading.textContent !== "One Size") {
                        heading.textContent = "One Size";
                    }
                }
            });

        // Consumer product selector
        document.querySelectorAll(".size-selector").forEach(function (section) {
            const codes = Array.from(
                section.querySelectorAll(".size-picker button[data-size]")
            ).map(function (button) {
                return button.dataset.size;
            });

            if (isOneSize(codes)) {
                Array.from(section.querySelectorAll("label")).forEach(function (label) {
                    if (label.textContent.trim().toUpperCase() === "ADULT") {
                        label.textContent = "One Size";
                    }
                });
            }
        });
    }

    function updateSizeLabels() {
        updateYouthSizeClassification();
        updateOneSizeLabels();
    }

    function initialize() {
        updateSizeLabels();

        // Handles product data loading, Vue rendering, and variant changes.
        let updateQueued = false;

        new MutationObserver(function () {
            if (updateQueued) return;

            updateQueued = true;
            requestAnimationFrame(function () {
                updateQueued = false;
                updateSizeLabels();
            });
        }).observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initialize);
    } else {
        initialize();
    }
})();
(function () {
    function isHalfSize(size) {
        return /^\d+[_-]1[_-]2$/.test(size);
    }

    function getNumericSize(size) {
        const match = size.match(/^(\d+)(?:[_-]1[_-]2)?$/);

        if (!match) return null;

        return Number(match[1]) + (isHalfSize(size) ? 0.5 : 0);
    }

    function formatSize(size) {
        return size.replace(
            /^(\d+)[_-]1[_-]2$/,
            "$1 1/2"
        );
    }

    function updateConsumerShoeSizes() {
        document
            .querySelectorAll(".size-selector .size-picker")
            .forEach(function (picker) {
                const buttons = Array.from(
                    picker.querySelectorAll("button[data-size]")
                );

                const containsHalfSizes = buttons.some(function (button) {
                    return isHalfSize(
                        button.getAttribute("data-size") || ""
                    );
                });

                // Do not reorder regular apparel sizes.
                if (!containsHalfSizes) return;

                const sortedButtons = buttons.slice().sort(function (a, b) {
                    const sizeA = getNumericSize(
                        a.getAttribute("data-size") || ""
                    );

                    const sizeB = getNumericSize(
                        b.getAttribute("data-size") || ""
                    );

                    if (sizeA === null || sizeB === null) return 0;

                    return sizeA - sizeB;
                });

                // Moving a button preserves its Vue click listener.
                const orderChanged = sortedButtons.some(
                    function (button, index) {
                        return button !== buttons[index];
                    }
                );

                if (orderChanged) {
                    sortedButtons.forEach(function (button) {
                        picker.appendChild(button);
                    });
                }

                sortedButtons.forEach(function (button) {
                    const rawSize =
                        button.getAttribute("data-size") || "";

                    const visibleLabel =
                        button.querySelector("span") || button;

                    const formattedSize = formatSize(rawSize);

                    if (
                        visibleLabel.textContent.trim() !== formattedSize
                    ) {
                        visibleLabel.textContent = formattedSize;
                    }
                });
            });
    }

    function updateDealerShoeSizes() {
        document
            .querySelectorAll(".size-selector-dealer")
            .forEach(function (selector) {
                const sizeRows = Array.from(
                    selector.querySelectorAll(
                        "li.dealer-selector-size"
                    )
                );

                const containsHalfSizes = sizeRows.some(function (row) {
                    const label = row.querySelector("label[for]");
                    const size = label
                        ? label.getAttribute("for") || ""
                        : "";

                    return isHalfSize(size);
                });

                if (!containsHalfSizes) return;

                const sortedRows = sizeRows.slice().sort(
                    function (a, b) {
                        const labelA = a.querySelector("label[for]");
                        const labelB = b.querySelector("label[for]");

                        const sizeA = getNumericSize(
                            labelA
                                ? labelA.getAttribute("for") || ""
                                : ""
                        );

                        const sizeB = getNumericSize(
                            labelB
                                ? labelB.getAttribute("for") || ""
                                : ""
                        );

                        if (sizeA === null || sizeB === null) return 0;

                        return sizeA - sizeB;
                    }
                );

                sortedRows.forEach(function (row) {
                    const label = row.querySelector("label[for]");

                    if (!label) return;

                    const rawSize =
                        label.getAttribute("for") || "";

                    label.textContent = formatSize(rawSize);
                });

                const lists = Array.from(
                    selector.querySelectorAll("ul")
                );

                if (!lists.length) return;

                if (lists.length === 1) {
                    sortedRows.forEach(function (row) {
                        lists[0].appendChild(row);
                    });

                    return;
                }

                const splitPoint = Math.ceil(
                    sortedRows.length / 2
                );

                sortedRows.forEach(function (row, index) {
                    const targetList =
                        index < splitPoint ? lists[0] : lists[1];

                    targetList.appendChild(row);
                });
            });
    }

    function updateShoeSizes() {
        updateConsumerShoeSizes();
        updateDealerShoeSizes();
    }

    let updateQueued = false;

    function scheduleUpdate() {
        if (updateQueued) return;

        updateQueued = true;

        requestAnimationFrame(function () {
            updateQueued = false;
            updateShoeSizes();
        });
    }

    function initialize() {
        updateShoeSizes();

        new MutationObserver(scheduleUpdate).observe(
            document.body,
            {
                childList: true,
                subtree: true
            }
        );
    }

    if (document.readyState === "loading") {
        document.addEventListener(
            "DOMContentLoaded",
            initialize
        );
    } else {
        initialize();
    }
})();